import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSubscriptionTagsInfo } from '@/api/subscriptionTags';
import { GenericSkeleton } from '@/components/loaders/GenericSkeleton';
import { TelemetryUpdateConfirmationDialog } from '@/components/subscriptions/DeviceTelemetryTransactionManagement';
import { TelemetryTransactionSummary } from '@/components/subscriptions/TelemetryTransactionSummary';
import { TransactionIntentFooter } from '@/components/transactions/TransactionIntentFooter';
import { TransactionLineChangeSummary } from '@/components/transactions/TransactionLineChangeSummary';
import { TransactionModal, TransactionSummary } from '@/components/transactions/TransactionModal';
import { TransactionContextProvider, useTransactionContext } from '@/context/transaction';
import {
    TelemetryLineChangeContextProvider,
    useTelemetryLineChanges,
} from '@/context/transaction/TelemetryLineChangeContext';

export const UnusedLinesPage = () => (
    <TransactionContextProvider type="subscription" prorationBehavior="always_invoice" defaultBackTarget="payment">
        <TelemetryLineChangeContextProvider>
            <UnusedLinesModal />
        </TelemetryLineChangeContextProvider>
    </TransactionContextProvider>
);

const UnusedLinesModal = () => {
    const { disableAllLines, setRetainExtraLines } = useTelemetryLineChanges();
    const { updateSubscription, backTarget } = useTransactionContext('subscription');
    const { data: subscriptionTagsInfo } = useSubscriptionTagsInfo();
    const navigate = useNavigate();
    const [isPending, setPending] = useState(true);

    function handleDone() {
        navigate(backTarget?.href ?? '/payment');
    }

    useEffect(() => {
        if (!subscriptionTagsInfo?.data) {
            setPending(true);
            return;
        }

        setRetainExtraLines(false);
        setPending(false);
    }, [disableAllLines, setRetainExtraLines, subscriptionTagsInfo?.data]);

    return (
        <TransactionModal>
            {isPending ? (
                <TransactionSummary>
                    <GenericSkeleton lines={4} />
                </TransactionSummary>
            ) : (
                <TelemetryTransactionSummary />
            )}
            <TransactionIntentFooter onConfirm={updateSubscription}>
                <TransactionLineChangeSummary hideUnusedLines />
            </TransactionIntentFooter>
            <TelemetryUpdateConfirmationDialog onDone={handleDone} />
        </TransactionModal>
    );
};
